import Obfuscate from 'react-obfuscate';
import { useParams } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import React from "react";

const Impressum = () => {

  const { lang } = useParams();
  const { t, i18n } = useTranslation();
  // Change the language dynamically
  React.useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  return (
    <>
      <h2>{t('texts.impressum.title1')}</h2>
      <p>
        Dr. Wigand Frank Grosse-Oetringhaus<br />
        Leipzigerstr. 43<br />
        10117 Berlin<br />
        <br />
      </p>
      <h2>{t('texts.impressum.title2')}</h2>
      <p>
        {/* {t('texts.impressum.telefon')}: <Obfuscate tel="+49 (30) 27 57 92 30" /><br /> */}
        {t('texts.impressum.email')}:{' '}
        <Obfuscate email="Grosse-Oetringhaus@web.de" aria-label="Grosse-Oetringhaus@web.de" />
        <br />
        <br />
      </p>
      <p dangerouslySetInnerHTML={{ __html: t('texts.impressum.footer')}} />
    </>)
};

export default Impressum;